import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import clevertap from "clevertap-web-sdk";

import EmailLoginHandler from "components/LoginAndRegister/EmailLoginHandler";
import Modal from "components/LoginAndRegister/Modal";
import PhoneLoginHandler from "components/LoginAndRegister/PhoneLoginHandler";

// assets
import { SvgUnlockDisCancel } from "assets/icons/js/SvgUnlockDisCancel";
import { SvgInfo } from "assets/icons/js/SvgInfo";
import { SvgUnlockDiscount } from "assets/icons/js/SvgUnlockDiscount";
import { SvgUnlockDiscountGift } from "assets/icons/js/SvgUnlockDiscountGift";
import { SvgLock } from "assets/icons/js/SvgLock";
import { ReactComponent as Loader } from "assets/spinning_red.svg";

import { ReactComponent as TickIcon } from "assets/green_tick.svg";

// customHooks
import { useUser } from "customHooks/useUser";
import { useMediaQuery } from "customHooks/useMediaQuery";

// helpers
import { axiosInstance, axiosInstance2 } from "helpers/axiosInstance";

// style
import "./style.scss";
import { bookingFaqs } from "lib/guestFaqData";
import { UserContext } from "store";
import axios from "axios";
import { FinishPhoneSignup } from "components/LoginAndRegister/FinishPhoneSignup";
import { useTheme } from "components/ListingNew/ListingTheme";

export const UnlockDiscount = ({
	price,
	id,
	name,
	checkin,
	checkout,
	theme,
}: any) => {
	// @ts-ignore
	const { data: next, isLoading } = useQuery({ queryKey: ["listing"] });

	// @ts-ignore
	const listingList = next?.data?.data?.listing_list;
	const isNext = false;

	// const {}=useContext(Listing)

	const [error, setError] = useState("");
	const [shouldShowModal, setShouldShowModal] = useState(false);
	const [phone, setPhone] = useState(true);

	const createDis = useMutation(
		() => {
			return axiosInstance({
				method: "post",
				url: "/create/deadline-coupon",
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
				data: {
					totalAmount: price,
					BOOKING_ID: id?.length < 14 ? id : "",
				},
			});
		},
		{
			onSuccess: () => {
				fetchData.refetch();
			},
			onError: (error) => {
				// @ts-ignore
				// @ts-ignore
				if (error?.response?.data?.error) {
					// @ts-ignore
					setError(error.response.data.error);
				}
			},
		},
	);

	const fetchData = useQuery(
		["unlockDisData", createDis.isSuccess],
		() => {
			return axiosInstance({
				method: "GET",
				url: `/fetch/deadline-coupon`,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			});
		},
		{
			retry: false,
			onSuccess: (res: any) => {
				localStorage.setItem(
					"unlock_best_offer",
					JSON.stringify({
						couponCode: res?.data?.data?.COUPON_CODE,
						expireAt: res?.data?.data?.EXPIRY_DATE,
						discount: res.data.data.DISCOUNT,
					}),
				);
			},
			onError: (err: any) => {
				localStorage.removeItem("unlock_best_offer");
			},
		},
	);

	const data = fetchData?.data?.data?.data;

	const [timer, setTimer] = useState("");

	const startTime = moment();
	const endTime = moment(data?.EXPIRY_DATE.split("T")[1], "HH:mm:ss")
		.add(5, "hours")
		.add(30, "minutes");

	const diffTimer = moment
		.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss")))
		.format("HH:mm:ss");

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime();
		}, 1000);

		return () => clearTimeout(intervalId);
	}, [startTime]);

	const updateRemainingTime = () => {
		setTimer(diffTimer);
	};

	const user = useUser();
	const width: any = useMediaQuery();

	const closeModal = () => {
		setShouldShowModal(false);
	};

	useEffect(() => {
		if (diffTimer === "23:59:57") {
			window.location.reload();
		}
	}, [diffTimer === "23:59:57"]);

	const {
		state: { currentUser },
	} = useContext(UserContext);
	const [extendReq, setExtendReq] = useState(false);

	useEffect(() => {
		if (sessionStorage.getItem("extend_coupon")) {
			setExtendReq(true);
		}
	}, []);
	const extendCoupon = async () => {
		try {
			const res = await axios.post(
				"https://go.saffronstays.com/api/request-deadline-coupon",
				{
					phone: currentUser.mobile,
					email: currentUser.email,
					villa: listingList?.file_reference.split("-")[0],
					// checkIn: listingList?.FROM_DATE,
					// checkOut: listingList?.TO_DATE,
					name: currentUser.firstName + " " + currentUser.lastName,
					bookingId: "",
					budget: listingList?.per_night_charge,
					source: "listing",
				},
				{
					headers: {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
					},
				},
			);
			if (res.data.success) {
				setExtendReq(true);
				sessionStorage.setItem("extend_coupon", "true");
			}
		} catch (err) {}
	};

	const [showPopUp, setShowPopUp] = useState(false);

	if (theme?.name === "xseries") {
		return null;
	}

	if (createDis.isError) {
		return (
			<div className="unlock__discount__container">
				<div
					className="unlock__coupon__discount-error"
					style={{
						marginBottom: "20px",
					}}
				>
					<span>
						<SvgUnlockDisCancel />
						<h4>
							Uh oh! Your special coupon has now expired.{" "}
							{extendReq ? (
								<span className="extended-req">
									<TickIcon /> Request Sent
								</span>
							) : (
								<button onClick={extendCoupon}>Extend Coupon</button>
							)}
						</h4>
					</span>
					{/* <p>
						Since your previous coupon expired,
						<strong> {error}</strong>
					</p> */}

					{extendReq && (
						<div className="extend-req-note">
							We’ve sent a request to extend your Coupon. You’ll receive a
							WhatsApp/Email on approval of extension
						</div>
					)}
				</div>
			</div>
		);
	}

	if (createDis.isLoading || fetchData.isLoading) {
		return (
			<div className="unlock__discount__container">
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						marginBottom: "20px",
					}}
					className="loader"
				>
					<Loader
						style={{
							width: "30px",
							height: "30px",
							color: "#3564e2",
						}}
					/>
				</div>
			</div>
		);
	}

	return (
		<>
			<Modal
				shouldShow={showPopUp}
				onRequestClose={() => {
					setShowPopUp(false);
				}}
			>
				<FinishPhoneSignup
					userUUID={localStorage.getItem("uuid")}
					redirect={() => window.location.reload()}
					onRequestClose={() => {
						setShowPopUp(false);
					}}
					userName={undefined}
					userEmail={undefined}
					userMobileNumber={undefined}
				/>
			</Modal>
			{!currentUser?.isTravelAgent && (
				<div className="unlock__dis">
					<div className="unlock__discount__container">
						{!fetchData.isSuccess ? (
							<div
								className={
									isNext
										? "unlock__special__next unlock__special"
										: "unlock__special"
								}
								onClick={() => {
									if (!user) {
										if (width <= 760) {
											window.location.href = "/login";
										} else {
											setShouldShowModal(true);
										}
									} else {
										if (
											!currentUser.fullName ||
											!currentUser.mobile ||
											!currentUser.email
										) {
											setShowPopUp(true);
											return;
										}
										createDis.mutateAsync();
										if (!createDis.isLoading) {
											clevertap.profile.push({
												Site: {
													Phone: "+" + currentUser.cc + currentUser.mobile,
													"MSG-whatsapp": true,
												},
											});
											if (id.length >= 15) {
												clevertap.event.push("unlock_best_offer", {
													phone: currentUser.mobile,
													email: currentUser.email,
													bookingValue: data?.TOTAL_AMOUNT_WITH_SERVICE,
													couponCode: data?.COUPON_ID,
												});
											} else {
												clevertap.event.push("unlock_discount_booking_page", {
													bookingId: id,
													name: name,
													checkin: checkin,
													checkout: checkout,
													active: data?.ISACTIVE,
													coupon_id: data?.COUPON_ID,
													coupon_code: data?.COUPON_CODE,
												});
											}
										}
									}
								}}
								style={{
									marginBottom: "20px",

									background: createDis.isLoading
										? "#fa4b4b"
										: theme?.unlockPrice?.background,
								}}
							>
								{width <= "768" && (
									<SvgLock
										id="listing-unlock"
										color={isNext ? "#8B001F" : "#ffffff"}
									/>
								)}
								{width <= "768" ? (
									<p style={{ color: theme?.unlockPrice?.color }}>
										Click to Unlock Best Price!!
									</p>
								) : (
									<p style={{ color: theme?.unlockPrice?.color }}>
										Better price available. Click here!
									</p>
								)}
							</div>
						) : (
							<>
								<div className="unlock__coupon__discount">
									<span className="left">
										Upto {data?.DISCOUNT}% OFF
										<SvgUnlockDiscountGift />
									</span>
									<span className="right">
										<p>
											Use your special coupon code
											<strong> {data?.COUPON_CODE} </strong>
											while booking
										</p>
										<div>
											Expires in
											<span>
												{timer && timer !== "Invalid date" ? timer : ""}
											</span>
										</div>
									</span>
								</div>
								<div className="unlock__dis-info">
									<SvgInfo />
									No refunds or re-schedule for bookings under this coupon
								</div>
							</>
						)}
					</div>
				</div>
			)}
			<Modal shouldShow={shouldShowModal} onRequestClose={closeModal}>
				{phone ? (
					<PhoneLoginHandler
						onRequestClose={closeModal}
						setPhone={setPhone}
						// @ts-ignore
						phone={phone}
					/>
				) : (
					<EmailLoginHandler
						onRequestClose={closeModal}
						setPhone={setPhone}
						phone={phone}
					/>
				)}
			</Modal>
		</>
	);
};
